export type DashlyControlVariant = "form" | "filter";

export const dashlyControlVariantClass = (
    baseClass: string,
    controlVariant: DashlyControlVariant = "form",
): string =>
    controlVariant === "filter" ? `${baseClass} ${baseClass}--filter` : baseClass;
